import { useParams } from 'react-router-dom';

export interface SubscriberDomainParams {
  groupId: string;
  subscriberId: string;
  entityId: string;
}

export const useSubscriberDomainParams = (): SubscriberDomainParams => {
  const { groupId, subscriberId, entityId } = useParams<{
    groupId: string;
    subscriberId: string;
    entityId: string;
  }>();

  if (!groupId || !subscriberId || !entityId) {
    throw new Error(
      `useSubscriberDomainParams was not able to find all required params in the url! Found: groupId: ${groupId}, subscriberId: ${subscriberId}, entityId: ${entityId}`,
    );
  }

  return { groupId, subscriberId, entityId };
};
